
<div class="tool-chunk">
    <div class="expand"      
   [class.expanded] ="expanded"
  >
    <button mat-icon-button color="primary" (click)="expand()" aria-label="expand to view simuation full screen">
      <i *ngIf='!expanded' class="fa-solid fa-maximize"></i>
      <i *ngIf='expanded' class="fa-solid fa-minimize"></i>
        </button>
  </div>
  <h1>Draft</h1>
</div>


<!-- WEAVER EDITING TOOLS -->
    <div class="tool-chunk">



        <button 
        mat-icon-button
        matTooltip= "Edit Draft Cells"
        [matMenuTriggerFor]="inks"
        [class.is-active]="dm.isSelected('draw','design_modes') && !dm.isSelected('material', 'draw_modes')"        >
        <i class="fas fa-edit"></i>
        </button>

        <!-- <ng-container *ngFor="let mode of dm.draw_modes">
            <button *ngIf="mode.value !== 'material'"
            mat-icon-button
            color="primary"

        [class.is-active]="dm.isSelected(mode.value,'draw_modes')"
        [name] = "mode.value"
        [disabled]= "viewonly"
        (click)="drawModeChange(mode.value)">
            <span class="{{mode.icon}}"></span>
        </button>
        </ng-container>
 -->


        <mat-menu #inks="matMenu">
            <ng-container *ngFor="let mode of dm.draw_modes">
                <button *ngIf="mode.value !== 'material'"
            class="menu-button" 
            mat-menu-item 
            [class.is-active]="dm.isSelected(mode.value,'draw_modes')"
            [name] = "mode.value"
            [disabled]= "viewonly"
            (click)="drawModeChange(mode.value)">
                <span class="{{mode.icon}}"></span>
                <span class="menu-item">{{mode.viewValue}}</span>
            </button>
            </ng-container>


        </mat-menu>

        <button 
        mat-icon-button
        color="primary"
        matTooltip= "Set Colors"
        [matMenuTriggerFor]="colors"
        [class.is-active]="dm.isSelected('draw','design_modes') && dm.isSelected('material', 'draw_modes')"        >
        <i class="fa-solid fa-paintbrush"></i>
        </button>

        <mat-menu #colors="matMenu">

            <ng-container *ngFor="let shuttle of ms.materials">
                <button class="menu-button" 
                mat-menu-item 
                (click)="drawWithMaterial(shuttle.id)">
                    <span class="swatch"  [style.background]="shuttle.color" ></span>
                    <span>{{shuttle.name }}</span>
                </button>
                </ng-container>


        </mat-menu>



        <button 
        mat-icon-button
        color="primary"
        matTooltip= "Select Region"
        [class.is-active]="dm.isSelected('select','design_modes')"
        (click)="select()">
        <i class="fas fa-expand"></i>
        </button>

        <button
        matTooltip= "Set Repeats"
        color="primary"
        mat-icon-button 
        [class.is-active] = "actions_modal && actions_modal.componentInstance != null"
        (click)='openActions()'><i class="fas fa-magic"></i></button>



        <!-- <button 
        mat-icon-button
        matTooltip= "Edit Draft Materials"
        [matMenuTriggerFor]="set_materials"
        [class.is-active]="selected_mode === 'material'"
        >
        <i class="fas fa-palette"></i>
        </button>

        <mat-menu #set_materials="matMenu">
        <ng-container *ngFor="let shuttle of draft.shuttles">
        <button class="menu-button" 
        mat-menu-item 
        (click)="drawWithMaterial(shuttle.id)">
            <span class="swatch"  [style.background]="shuttle.color" ></span>
            <span>{{shuttle.name }}</span>
        </button>
        </ng-container>

        <button class="menu-button" 
        mat-menu-item 
        (click)="openMaterialEditor()">
        <span class="fa fa-plus"></span>
        <span>Add / Edit Materials</span>
        </button>
        </mat-menu> -->

    </div>
    

 

<!-- VIEW TOOLS -->

    <div class="tool-chunk slider" >

        <button color="primary" mat-icon-button (click)="zoomIn()"><i class="fas fa-search-plus"></i></button>
        
        <div class="view_slider">
        <mat-slider 
        tickInterval=".1" 
        color="primary"
        [vertical]="true"
        step=".1"
        min="0" 
        max="2" 
        value="{{render.zoom}}" 
        (change)="zoomChange($event, 'slider')"></mat-slider>
    </div> 

       <button mat-icon-button color="primary"  (click)="zoomOut()"><i class="fas fa-search-minus"></i></button> 
       


    </div>


   
<!-- EQUIPMENT SETTINGS -->


 
 
   
    <!-- <div  class="designtools" *ngIf="source==='mixer'">

        <div class="undoredo">
        <button #undoEvent 
        mat-stroked-button 
        color="primary"
        (click)="undoClicked($event);"
        [disabled]="ss.undo_disabled || viewonly"
        matTooltip ="undo">
        <i class="fas fa-undo"></i> Undo
        </button>

        <button #redoEvent 
        mat-stroked-button 
        color="primary"
        (click)="redoClicked($event);"
        [disabled]="ss.redo_disabled  || viewonly"
        matTooltip ="redo">
        <i class="fas fa-redo"></i>Redo
        </button>
        </div>


    
        <button 
        mat-stroked-button 
        color="primary"
        matTooltip= "Blank Draft"
        (click)="createNewDraft()">
        <i class="fas fa-chess-board"></i> Add Blank Draft to Workspace
        </button>
    

  
        <button 
        mat-stroked-button 
        color="primary"
        matTooltip= "Note"
        color="primary"
        (click)="addNote()">
        <i class="fas fa-comment"></i> Add Comment to Workspace
        </button>



        <app-quickop
            (onOperationAdded)="addOperation($event)"
        >
        </app-quickop>

        <button 
        mat-button
        [class.is-active] = "op_modal && op_modal.componentInstance != null"
        matTooltip= "Operation"
        (click)="openOps()">
        <i class="fas fa-project-diagram"></i> View All Operations
        </button>
    </div> -->


